// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.user-avatar_user-thumbnail_PQgAt {
    width: 2rem;
    height: 2rem;
    border-radius: calc(0.5rem / 2);
    vertical-align: middle;
    box-shadow: 0 0 0 1px var(--ui-black-transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/user-avatar.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,sBAAsB;IACtB,iDAAiD;AACrD","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.user-thumbnail {\n    width: 2rem;\n    height: 2rem;\n    border-radius: calc(0.5rem / 2);\n    vertical-align: middle;\n    box-shadow: 0 0 0 1px var(--ui-black-transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user-thumbnail": `user-avatar_user-thumbnail_PQgAt`,
	"userThumbnail": `user-avatar_user-thumbnail_PQgAt`
};
export default ___CSS_LOADER_EXPORT___;
